export default __webpack_public_path__ + "static/media/apcer.d99961b4.mp4";